import React, { useState, useEffect, useRef } from 'react';
import { Formik, Form } from 'formik';
import { useHistory } from 'react-router';
import * as Yup from 'yup';
import { Box } from '@material-ui/core';
import { LOGOUT } from 'ConstComponents';
import { Select as SENDER_SELECT } from 'Components/Api/OnlyAPI';
import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import { MaterialNumberField } from 'Components/Inputes/FormikMaterialNumberInput';
import { Container, Grid, Paper, Hidden, Typography } from '@material-ui/core';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import {
    PLEASE_PROVIDE_VALID,
    MONEY_TRANSFER_CODE
} from 'Components/Helper/Messages';
import BeneficiaryList from './BeneficiaryList';
import { useLocation } from 'react-router-dom';
import { PrimaryButton } from 'Components/Inputes/CustomButton';
import { CONSUMER_NUMBER_FONT_SIZE } from 'Config';
import HOCLoader from 'Components/Loader/HOCLoader';
import AutoSubmitMobileForSender from 'Components/Helper/AutoSubmitMobileForSender';
import { Last10Report } from 'Pages/InnerPages/Report/Last10Report';
import AddbeneficiaryIcon from 'Components/SvgButtons/AddbeneficiaryIcon';
import {CheckOnboardingStatus as SELECT_AGENTCODE} from 'Components/Api/OnlyAPIOnboardingAPI';

const CustomContainer = HOCLoader(Container);

const SenderSearch = ({ ActiveDMTName }) => {
    const formRef = useRef();
    const classes = commonStyle();
    const location = useLocation();
    const history = useHistory();
    const [senderNo, setSenderNo] = useState('');
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [addBeneficiary, setAddBeneficiary] = useState('none');
    const [serviceCode, setServiceCode] = useState(MONEY_TRANSFER_CODE);
    const [consumerNumberFontSize, setConsumerNumberFontSize] = useState('');
    async function fetchConsumerNumberFontSize() {
        setConsumerNumberFontSize(await CONSUMER_NUMBER_FONT_SIZE());
    }
    const Mobile = location?.state?.Mobile;

    const [formObject, setFormObject] = useState({
        Mobile: '',
        Name: '',
        SenderID: '',
        isAddBeneficiary: false,
        RemainingLimit: '',
        Consumed: ''
    });

    useEffect(() => {
        fetchConsumerNumberFontSize();
        select();
        setLoading(false);
        Select_AGENTCode();
    }, []);

    useEffect(() => {
        const timer = setTimeout(() => {
            if (formRef === undefined) return;

            if (!formRef.current) return;

            if (formRef.current.values === undefined) return;

            if (formRef.current.values.Mobile === undefined) return;

            if (formRef.current.values.Mobile.length !== 10) return;

            formRef.current.handleSubmit();
        }, 500);
        return () => clearTimeout(timer);
    }, []);

    const Select_AGENTCode = async () => {
            setLoading(true);  
            const response = await SELECT_AGENTCODE();
            setLoading(false);
            if (!response.isAuthorized) {
                LOGOUT();
            }
            if (!response.status) {
                setIsError(true);
                setSeverity('error');
                setResponseMessage(response.data);
                history.push('/OnlyAPIOnboarding ');
                return;
            }
            history.push('/OADMT_SenderSearch');
            return;
        };

    const select = async () => {
        let primaryID = Mobile;

        setFormObject({
            ...formObject,
            Mobile: primaryID,
            Name: '',
            SenderID: '',
            RemainingLimit: '',
            Consumed: '',
            DMTName: ActiveDMTName
        });
    };

    const submithandle = async (values, { setSubmitting, resetForm }) => {
        setServiceCode('');
        setSenderNo('');

        values.DMTName = ActiveDMTName;

        var requestObj = JSON.stringify(values);

        setLoading(true);
        setIsError(false);

        if (values.isAddBeneficiary) {
            let params = {
                Mobile: values.Mobile,
                SenderName: values.Name,
                DMTName: ActiveDMTName
            };
            history.push('/OADMT_BeneficiaryAdd', params);
            return;
        }

        setFormObject({
            ...formObject,
            Mobile: values.Mobile,
            Name: '',
            SenderID: '',
            RemainingLimit: '',
            Consumed: ''
        });
        var response = await SENDER_SELECT(requestObj);
        
        var data = JSON.parse(response.data);
        setLoading(false);
  
        if (!response.isAuthorized) LOGOUT();

        setServiceCode(MONEY_TRANSFER_CODE);
        setSeverity('success');

        if (!response.status) {
            setSeverity('error');
            setIsError(true);
            setResponseMessage(data.Message);
            if (data.NSDLKYCStatus == false) {
                let params = {
                    Mobile: values.Mobile,
                    DMTName: ActiveDMTName
                };
                history.push('/OADMT_SenderOnboard', params);
                return;
            }
            if (
                response.Message ===
                'Your KYC is not approved, please contact to customer care'
            ) {
                history.push('/KycIndex');
                return;
            }
            setLoading(false);
            return;
        }
        setAddBeneficiary('inline');
        setFormObject({
            Mobile: data.Mobile,
            Name: data.Name,
            Consumed: data.Consumed,
            RemainingLimit: data.RemainingLimit,
            Pipe: values.Pipe,
            isAddBeneficiary: false,
            DMTName: ActiveDMTName
        });

        setSenderNo(data.Mobile);
    };

    const FormValidationSchema = Yup.object({
        Mobile: Yup.string()
            .required(PLEASE_PROVIDE_VALID + 'mobile')
            .length(10, PLEASE_PROVIDE_VALID + 'mobile')
    });

    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                innerRef={formRef}
                enableReinitialize={true}
                initialValues={formObject}
                validationSchema={FormValidationSchema}
                onSubmit={submithandle}
                resetForm={formObject}
            >
                {({ values, setFieldValue, handleSubmit }) => {
                    return (
                        <Form>
                            <AutoSubmitMobileForSender />
                            <Grid item xs={12}>
                                <Paper className={classes.PaperStyle}>
                                    <Grid container spacing={2}>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <MaterialNumberField
                                                font_size={
                                                    consumerNumberFontSize
                                                }
                                                label="Mobile Number"
                                                name="Mobile"
                                                type="Mobile"
                                                length={10}
                                                typed_length={1}
                                                placeholder="Mobile Number"
                                            />
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={2}
                                            lg={2}
                                        >
                                            <PrimaryButton
                                                title="Search"
                                                disabled={loading}
                                                onClick={(e) => {
                                                    setFieldValue(
                                                        'isAddBeneficiary',
                                                        false
                                                    );
                                                    setAddBeneficiary('none');
                                                    handleSubmit(e);
                                                }}
                                            >
                                                Search
                                            </PrimaryButton>
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <Box display={addBeneficiary}>
                                                <PrimaryButton
                                                    title="Add Beneficiary"
                                                    disabled={loading}
                                                    endIcon={
                                                        <AddbeneficiaryIcon />
                                                    }
                                                    onClick={(e) => {
                                                        setFieldValue(
                                                            'isAddBeneficiary',
                                                            true
                                                        );
                                                        handleSubmit(e);
                                                    }}
                                                >
                                                    Add Beneficiary
                                                </PrimaryButton>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Box
                                                display="flex"
                                                flexDirection="column"
                                                p={2}
                                            >
                                                <Grid container>
                                                    <Grid item xs={3}>
                                                        <Box
                                                            display="flex"
                                                            justifyContent="flex-start"
                                                        >
                                                            <Typography
                                                                variant="body1"
                                                                fontWeight="bold"
                                                            >
                                                                Name :
                                                            </Typography>
                                                            <Typography
                                                                variant="body1"
                                                                marginLeft="10px"
                                                                style={{
                                                                    fontWeight:
                                                                        'bold',
                                                                    marginLeft:
                                                                        '5px'
                                                                }}
                                                            >
                                                                {
                                                                    formObject.Name
                                                                }
                                                            </Typography>
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={3}>
                                                        <Box
                                                            display="flex"
                                                            justifyContent="flex-start"
                                                        >
                                                            <Typography
                                                                variant="body1"
                                                                fontWeight="bold"
                                                            >
                                                                Monthly Limit :
                                                            </Typography>
                                                            <Typography
                                                                variant="body1"
                                                                marginLeft="10px"
                                                                style={{
                                                                    fontWeight:
                                                                        'bold',
                                                                    marginLeft:
                                                                        '5px'
                                                                }}
                                                            >
                                                                {
                                                                    formObject.RemainingLimit
                                                                }
                                                            </Typography>
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={3}>
                                                        <Box
                                                            display="flex"
                                                            justifyContent="flex-start"
                                                        >
                                                            <Typography
                                                                variant="body1"
                                                                fontWeight="bold"
                                                            >
                                                                Consumed Limit :
                                                            </Typography>
                                                            <Typography
                                                                variant="body1"
                                                                marginLeft="10px"
                                                                style={{
                                                                    fontWeight:
                                                                        'bold',
                                                                    marginLeft:
                                                                        '5px'
                                                                }}
                                                            >
                                                                {
                                                                    formObject.Consumed
                                                                }
                                                            </Typography>
                                                        </Box>
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <Hidden xsUp>
                                                <MaterialTextField
                                                    label="SenderID"
                                                    name="SenderID"
                                                    type="text"
                                                    readOnly={true}
                                                    placeholder="SenderID"
                                                />
                                            </Hidden>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>
                        </Form>
                    );
                }}
            </Formik>

            <BeneficiaryList
                senderNo={senderNo}
                ActiveDMTName={ActiveDMTName}
                senderName={formObject.Name}
                setIsError={(value) => {
                    setIsError(value);
                }}
                setSeverity={(value) => {
                    setSeverity(value);
                }}
                setLoading={(value) => {
                    setLoading(value);
                }}
                setResponseMessage={(value) => {
                    setResponseMessage(value);
                }}
                formRef={formRef}
            />

            <Last10Report
                ServiceID={serviceCode}
                setIsError={(value) => {
                    setIsError(value);
                }}
                setSeverity={(value) => {
                    setSeverity(value);
                }}
                setLoading={(value) => {
                    setLoading(value);
                }}
                setResponseMessage={(value) => {
                    setResponseMessage(value);
                }}
                formRef={formRef}
            />
        </CustomContainer>
    );
};
export default SenderSearch;
